/**
 * Читает данные, предзагруженные host-приложением на стороне SSR
 * (`serverPreloadEndpoint` в `wcExposes`, `vite.config.ts`).
 *
 * BFF отвечает в формате `PreloadedResources` (`resources` + `data`): хост сам
 * конвертирует `resources` в тэги `<link rel="preload">` и кладёт уже
 * распакованный `data` в `window["__PRELOAD_<mf-name>__"]` — здесь его
 * достаточно прочитать как есть, без дополнительной распаковки.
 *
 * Доступны сразу при первой загрузке страницы (до `onMounted`), так как хост
 * кладёт их в HTML ещё на сервере.
 *
 * Примечание: хук срабатывает только на SSR — при SPA-переходах в МФ данных
 * не будет.
 */
export const getServerPreloadedData = (): unknown => {
  const mfName = import.meta.env.VITE_MF_NAME;
  const key = `__PRELOAD_${mfName}__`;

  return (window as unknown as Record<string, unknown>)[key];
};
